var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26.006,
    viewBox: "0 0 26 26.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search-solid",
    d: "M25.646,22.484,20.583,17.42a1.218,1.218,0,0,0-.863-.356h-.828a10.558,10.558,0,1,0-1.828,1.828v.828a1.218,1.218,0,0,0,.355.863l5.063,5.063a1.214,1.214,0,0,0,1.722,0l1.437-1.437A1.225,1.225,0,0,0,25.646,22.484ZM10.563,17.065a6.5,6.5,0,1,1,6.5-6.5A6.5,6.5,0,0,1,10.563,17.065Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic-search.4bbd51291d2ed6aed5a7787a3201e832.svg";
export { ForwardRef as ReactComponent };